import { __assign } from "tslib";
import React from 'react';
import { Bubble } from '@tencent/tea-component';
import classNames from 'classnames';
;
export function BuyBubble(props) {
    var _a;
    return (React.createElement(Bubble, __assign({}, props, { className: classNames('tea-for-buy-icon__bubble', (_a = props.className) !== null && _a !== void 0 ? _a : '') })));
}
//# sourceMappingURL=BuyBubble.js.map